module.exports = __webpack_public_path__ + "static/media/star-tb-ico.e93a67f7.svg";